import { Component, OnInit } from '@angular/core';
import { WizardNotificationHistoryService } from 'src/app/dashboard/widgets/wizard-notification-history/wizard-notification-history.service';
import { DashboardWidgetLookup, DashboardWidgetContent } from '@serengeti/serengeti-dashboard';

@DashboardWidgetLookup('WizardMarketHistoryComponent')
@Component({
  selector: 'app-wizard-market-history',
  templateUrl: './wizard-market-history.component.html',
  styleUrls: ['./wizard-market-history.component.scss']
})
export class WizardMarketHistoryComponent implements OnInit, DashboardWidgetContent {

  public feed: any[];

  constructor(private _feedService: WizardNotificationHistoryService) {
  }

  property(): boolean {
    return false;
  }
  
  configure(setting: any): void {
  }

  ngOnInit() {
    this._loadFeed();
  }

  expandMessage(message: any) {
    message.expanded = !message.expanded;
  }

  private _loadFeed() {
    this.feed = this._feedService.getData();
  }
}
